import React, { useEffect, useState } from 'react';
import { useApi } from '../hooks/useApi';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import { Megaphone, Send, Users } from 'lucide-react';

export default function Broadcast() {
  const api = useApi();
  const { can } = useAuth();
  const [message, setMessage] = useState('');
  const [userCount, setUserCount] = useState(0);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(null);
  const [preview, setPreview] = useState(false);

  useEffect(() => {
    api.get('/users').then(d => {
      if (d && !d.error) setUserCount(d.users?.length || 0);
    });
  }, []);

  async function sendBroadcast() {
    if (!message.trim()) return toast.error('Message likhein');
    if (!window.confirm(userCount + ' users ko message bhejna chahte hain?')) return;
    setSending(true);
    setSent(null);
    try {
      const d = await api.post('/broadcast', { message });
      if (d?.success) {
        toast.success('Broadcast bhej diya gaya! (' + (d.sent || 0) + ' users)');
        setSent(d.sent || 0);
        setMessage('');
      } else {
        toast.error(d?.error || 'Broadcast nahi hua');
      }
    } catch(e) {
      toast.error('Error: ' + e.message);
    }
    setSending(false);
  }

  if (!can('broadcast')) {
    return (
      <div className="page">
        <div className="page-header">
          <div className="section-title">📢 Broadcast</div>
        </div>
        <div className="card" style={{ textAlign: 'center', padding: 40, color: 'var(--text-muted)' }}>
          ⛔ Aapko broadcast ka permission nahi hai.
        </div>
      </div>
    );
  }

  return (
    <div className="page">
      <div className="page-header">
        <div className="section-title">📢 Broadcast</div>
        <div className="section-sub">Sab users ko ek saath message bhejein</div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 320px', gap: 20, alignItems: 'start' }}>
        <div className="card">
          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 16 }}>
            ✍️ Message Likhein
          </div>
          <div className="field">
            <label className="label">Broadcast Message *</label>
            <textarea
              className="textarea"
              placeholder={'Assalam o Alaikum! 🌹\n\nAaj ka paigham...\n\n— HRN Team'}
              value={message}
              onChange={e => setMessage(e.target.value)}
              style={{ minHeight: 200, fontSize: 14, lineHeight: 1.8 }}
            />
            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>
              {message.length} characters
            </div>
          </div>

          {sent !== null && (
            <div style={{ padding: '10px 14px', background: 'var(--emerald-900)', border: '1px solid var(--emerald-700)', borderRadius: 8, fontSize: 13, color: 'var(--emerald-300)', marginBottom: 12 }}>
              ✅ {sent} users ko message pohonch gaya!
            </div>
          )}

          <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
            <button className="btn btn-ghost" onClick={() => setPreview(p => !p)}>
              👁️ {preview ? 'Preview Band' : 'Preview'}
            </button>
            <button className="btn btn-primary" onClick={sendBroadcast} disabled={sending || !message.trim()}>
              {sending
                ? <><span className="spinner" style={{ width: 14, height: 14 }} /> Bhej raha hai...</>
                : <><Send size={14} /> Broadcast Karein</>
              }
            </button>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div className="card">
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
              <div className="stat-icon" style={{ background: 'var(--emerald-800)', border: '1px solid var(--emerald-600)', color: 'var(--emerald-300)', width: 36, height: 36 }}>
                <Users size={16} />
              </div>
              <div>
                <div className="stat-value" style={{ fontSize: 20 }}>{userCount}</div>
                <div className="stat-label">Total Recipients</div>
              </div>
            </div>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', lineHeight: 1.7 }}>
              Sab registered users ko message jayega. Blocked users ko nahi jayega.
            </div>
          </div>

          <div className="card">
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 10 }}>💡 Tips</div>
            <ul style={{ fontSize: 12, color: 'var(--text-muted)', lineHeight: 2, paddingLeft: 16 }}>
              <li>Urdu mein likhein</li>
              <li>Salaam se shuru karein</li>
              <li>Zyada bara message na bhejein</li>
              <li>Rate limit hogi — 200ms delay per user</li>
            </ul>
          </div>
        </div>
      </div>

      {preview && message && (
        <div className="card" style={{ marginTop: 20 }}>
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 12 }}>📱 WhatsApp Preview</div>
          <div style={{
            background: '#0a1a0f', border: '1px solid var(--border-light)',
            borderRadius: 12, padding: '12px 16px', maxWidth: 380,
            fontSize: 15, lineHeight: 2, color: 'var(--text-primary)',
            direction: 'rtl', whiteSpace: 'pre-wrap'
          }}>
            {message}
          </div>
        </div>
      )}
    </div>
  );
}
